<template>
  <CContainer class="d-flex content-center min-vh-100">
    
    <CRow>
      
      <CCol>
        <CCardGroup>
          <CCard class="p-4 login-card">
            <CCardBody>
              <CForm @submit.prevent="login" method="POST">
                <h1>Ingresar</h1>
                <p class="text-muted">Bienvenido, ingrese sus datos.</p>
                <div class='bg-danger p-2 mb-4 error-message' v-if='showMessage'>
                  <CIcon name='cil-ban' color='white' />
                  <span class='ml-xl-2'>{{message}}</span>
                </div>
                <CInput
                  v-model="email"
                  prependHtml="<i class='cui-user'></i>"
                  placeholder="Email"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="password"
                  prependHtml="<i class='cui-lock-locked'></i>"
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col='3' class='d-flex align-items-center'> <CInputCheckbox label='Recordarme' class='py-0 my-auto'/> </CCol>
                  <CCol col='9' class='text-right'><router-link to="/recuperar-contrasena">¿Olvidó su contraseña?</router-link></CCol>
                </CRow>
               
                <CRow>
                  <CCol col="12" class='pt-3'>
                    <CButton type="submit" color="primary" class="mx-auto px-4">Ingresar</CButton>
                  </CCol>
                
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            
            text-color="white"
            class="text-center py-5 d-md-down-none logo-side "
          
          >
          <CCardBody class='d-flex'>
                      <CImg class='m-auto d-block' width='250' src='img/logo.png'></CImg>

          </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
      <CCol class='d-md-none'>
        <CImg width='250' src='img/logo.png' class='d-md-down-block d-md-up-none'></CImg>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>



    export default {
      name: 'Login',
      data() {
        return {
          email: '',
          password: '',
          showMessage: false,
          message: '',
        }
      },
      methods: {
        goRegister(){
          this.$router.push({ path: 'register' });
        },
        login() {
         
          this.showMessage = false;
          this.$api.auth.login({
            email: this.email,
            password: this.password
          }).then(res => {
            if(res.data){
              this.setCookie(res.data);
         
              // Almacenamos el user en vuex para futuras referencias
              //
              console.log(res.data);
              // Derecho a las ordenes
              location.replace('ordenes');
              // this.$router.push('/ordenes');
              //this.$router.push({ path: '/ordenes' });
            }
          }).catch(err => {
            // TODO: VER MENSAJES DE ERROR
            console.log('error', err)

            this.message = 'Datos de ingreso incorrectos, por favor intente nuevamente';
            this.showMessage = true;
          });
        
        },
        setCookie(data){
          this.$cookies.set(this.$apiTokenName, data.access_token, data.expires)
        }
      }
    }

</script>

<style lang="scss">
.login-card{
  border: none;
}
.logo-side{
  background-color: #d8dbe0;
}
.error-message{
  border-radius: 4px;
}
</style>
